// AccountCreate.tsx
import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import NewAccountForm from "./NewAccountForm.tsx";
import ContactInfoForm from "./ContactInfoForm.tsx";
import { useLocation } from "react-router";
import { HomeActions } from "../../../Services/_actions/home.action.js";

// Define ContactData type globally or here
export type ContactData = {
  name: string;
  designation: string;
  department: string;
  email: string;
  mobile: string;
  singlePointOfContact: string;
};

const emptyContact: ContactData = {
  name: "",
  designation: "",
  department: "",
  email: "",
  mobile: "",
  singlePointOfContact: "no",
};

const AccountCreate: React.FC = () => {
  const location = useLocation();
  const passedAccount = location.state?.account;
  const accountId = passedAccount?.account_id || "";
  const [contacts, setContacts] = useState<ContactData[]>([emptyContact]); // Default with one contact
  const actions = HomeActions();
  const [validateContacts, setValidateContacts] = useState<() => boolean>(() => () => true);

  const fetchAccountDetails = async (accountId: string) => {
    try {
      const response = await actions.getAccountDetailsById(accountId);
      if (response?.status === 200) {
        const accountData = response.data;
        const initialContacts = accountData.contacts ?? [];
        if (initialContacts.length === 0) {
          initialContacts.push(emptyContact);
        }
        setContacts(initialContacts);
      } else {
        console.error("Failed to fetch account details:", response);
      }
    } catch (error) {
      console.error("Error fetching account details:", error);
    }
  };
  useEffect(() => {
    if (accountId) {
      fetchAccountDetails(accountId);
    }
  }, [accountId]);


  return (
    <Box sx={{ display: "flex", height: "85vh", gap: 2, p: 0 }}>
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <NewAccountForm getContacts={() => contacts} refreshAccountData={() => fetchAccountDetails(accountId)}   validateContacts={validateContacts}
 />
      </Box>

      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <ContactInfoForm contacts={contacts} setContacts={setContacts}   validateContactsExternally={(validateFn) => setValidateContacts(() => validateFn)}/>
      </Box>
    </Box>
  );
};

export default AccountCreate;
